import { styled, Tab, Tabs } from "@mui/material";

export const TabsStyle = styled(Tabs)(({ theme }) => ({
  minHeight: 0,
  "& .MuiTabs-indicator": {
    height: "100%",
    borderRadius: 8,
    backgroundColor: theme.palette.primary.main,
    zIndex: 1,
    width: "100%",
  },
}));

export const TabStyle = styled(Tab)(({ theme }) => ({
  minHeight: 40,
  minWidth: 120,
  textTransform: "none",
  fontSize: "1rem",
  lineHeight: "1.4375rem",
  fontWeight: 400,
  color: theme.palette.grey[500],
  alignItems: "center",
  borderRadius: 8,
  padding: "8px 16px",
  "&:hover": {
    color: theme.palette.primary.main,
  },
  "&.Mui-selected": {
    fontSize: "1rem",
    fontWeight: 700,
    color: "white",
    zIndex: 9,
  },
}));
